/**
 * @author Martin Leonov <martin.leonov@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

/* eslint-env browser */

/**
 * @import { FileSystemMapper as IFileSystemMapper } from '../../../../core/file/system'
 * @import FileSystemManager from './file-system-manager'
 */

/**
 * Mapovač cest souborového systému pro Origin Private File System.
 * @implements {IFileSystemMapper}
 */
export default class FileSystemMapper {
  /**
   * @param {FileSystemManager} fileSystemManager
   */
  constructor(fileSystemManager) {
    this.fileSystemManager = fileSystemManager;
  }

  /** @type {IFileSystemMapper['hasFile']} */
  hasFile() {
    return true;
  }

  /** @type {IFileSystemMapper['hasLocalhost']} */
  hasLocalhost() {
    return false;
  }

  /** @type {IFileSystemMapper['toFileUrl']} */
  async toFileUrl(path) {
    const fileHandle = await this.fileSystemManager.getFileHandle(path);
    return URL.createObjectURL(await fileHandle.getFile());
  }

  /** @type {IFileSystemMapper['toLocalhostUrl']} */
  async toLocalhostUrl(path) {
    throw await new Error('Web platform does not support localhost URLs.');
  }
}
